/* eslint-disable */
class WeChatShare {

    attach(data) {
        if (this.isWechat()) {
            this.generate(data);
        }
    }

    generate(data) {
        const shareList: string[] = [
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
        ];

        const script = document.createElement('script');
        script.onload = () => {
            wx.ready(() => {
                shareList.forEach((item) => {
                    wx[item](data);
                });
            });
            getWeixinCgf();
        };
        script.async = true;
        script.type = 'text/javascript';
        script.src = '//res.wx.qq.com/open/js/jweixin-1.2.0.js';
        document.head.appendChild(script);

        const getWeixinCgf = () => {
            const api = `/api/v1/mp_jsapi_ticket?url=${encodeURIComponent(window.location.href.split('#')[0])}`;
            this.ajaxGET(api)
                .then((res) => {
                    wx.config({
                        appId: 'wxcef2bc6c0af3b096',
                        timestamp: res.timestamp,
                        nonceStr: res.noncestr,
                        signature: res.signature,
                        jsApiList: [...shareList],
                    });
                });
        };
    }

    isWechat() {
        return /MicroMessenger/i.test(navigator.userAgent);
    }

    ajaxGET(url) {
        return new Promise((r, j) => {
            const xhr = new XMLHttpRequest();
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304) {
                        r(JSON.parse(xhr.responseText));
                    } else {
                        j(xhr.status);
                    }
                }
            };
            xhr.open('GET', url);
            xhr.send(null);
        });
    }
}

export default new WeChatShare();
